<template>
  <el-drawer
    :visible.sync="planDialogVisible"
    custom-class="study-plan-dialog"
    :modal="false"
    :append-to-body="true"
    :show-close="false"
    :with-header="false"
    width="360"
    size="260"
  >
    <div class="plan_box">
      <div class="editPlan_btn">
        <div class="btn" @click="addStudyPlan">
          <img src="@/assets/images/studyPlan/btn.png" alt="" />
          管理学习计划
        </div>
      </div>
      <div class="people_num">
        <span style="color: #2d68fe">111</span> &nbsp;人已制定学习计划
      </div>
      <div class="plan_calendar">
        <div
          class="calendar-box"
          :class="{
            'calendar-box02': switchIcon01,
          }"
        >
          <div class="time-switch-box01" @click="handClick01">
               <span class="switch-box-text"    v-if="switchIcon01">展开</span>
            <span class="switch-box-text"  v-else>收起</span>
          <i class="el-icon-arrow-down" v-if="switchIcon01" ></i>
            <i class="el-icon-arrow-up" v-else></i>
           
          </div>
          <div class="time-switch-box02">
            <div
              class="time-switch-box02-position"
              @click="toggleDatePicker(1)"
            >
              <!-- <i class="el-icon-arrow-up"></i> -->
              <i class="el-icon-arrow-down"></i>
            </div>
            <el-date-picker
              class="date-picker-style"
              ref="datePicker01"
              v-model="value2"
              type="month"
              @change="hangChange01"
              placeholder="选择月"
            >
            </el-date-picker>
          </div>
          <el-calendar v-model="currentDate">
             <!-- @click="hasEvents(date) && showDayEvents(date)" -->
            <template slot="dateCell" slot-scope="{ date, data }">
              <div
                :class="{ has: hasEvents(date) }"
                @click="showDayEvents(date)"
               
                class="day"
              >
                {{ data.day.split("-").slice(2).join("") }}
              </div>
              <!-- <div
                :class="{ hasNew: hasEvents(date), has: hasEvents(date) }"
                @click="hasEvents(date) && showDayEvents(date)"
                class="day"
              >
                {{ data.day.split("-").slice(2).join("") }}
              </div> -->
            </template>
          </el-calendar>
        </div>

        <div class="plan_list">
          <div
            v-for="(event, index) in selectedDate.list"
            :key="index"
            class="timeline-item"
          >
            <img
              class="timeline-item-img"
              v-if="event.status == '6'"
              src="@/assets/images/workImg01.png"
              alt=""
            />
            <template v-else>
              <img
                class="timeline-item-img"
                v-if="
                  getStatus(
                    event.startTime,
                    formatEndTime(event.startTime, event.studyDuration),
                  ) == '2'
                "
                src="@/assets/images/workImg02.png"
                alt=""
              />
              <img
                v-if="
                  getStatus(
                    event.startTime,
                    formatEndTime(event.startTime, event.studyDuration),
                  ) == '1'
                "
                class="timeline-item-img"
                src="@/assets/images/workImg03.png"
                alt=""
              />
              <img
                v-if="
                  getStatus(
                    event.startTime,
                    formatEndTime(event.startTime, event.studyDuration),
                  ) == '0'
                "
                class="timeline-item-img"
                src="@/assets/images/workImg04.png"
                alt=""
              />
            </template>

            <div class="time-title">
              <img src="@/assets/images/studyPlan/time.png" alt="" />
              {{ formatTime(event.startTime) }} -
              {{ formatEndTime(event.startTime, event.studyDuration) }}
            </div>
            <div class="title_name">
              <img
                src="@/assets/images/studyPlan/icon_textbook.png"
                alt=""
                v-if="event.type === 'textBook'"
              />

              <img
                src="@/assets/images/studyPlan/icon_test.png"
                alt=""
                v-else
              />
              {{ event.type === "textBook" ? "阅读" : "习题" }}
              {{ event.name }}
            </div>
            <div class="statusNew statusNew01" v-if="event.status == '6'">
              已完成
            </div>
            <template v-else>
              <div
                v-if="
                  getStatus(
                    event.startTime,
                    handChange04(event.startTime, event.studyDuration),
                  ) == '0'
                "
                class="statusNew statusNew01"
              >
                未开始
              </div>
              <div
                v-else-if="
                  getStatus(
                    event.startTime,
                    handChange04(event.startTime, event.studyDuration),
                  ) == '2'
                "
                class="statusNew statusNew02"
              >
                未完成
              </div>
              <div class="statusNew statusNew03" v-else>
                去完成 <i class="el-icon-arrow-right"></i>
              </div>
            </template>

            <div class="timeline-content" v-if="false">
              <div class="timeline-status">
                <!-- 只保留待完成和已完成状态 -->
                <template v-if="event.status != '6'">
                  <el-tag type="warning" size="small">待完成</el-tag>
                  <el-button
                    type="success"
                    size="small"
                    @click="completeEvent(event)"
                    >完成计划</el-button
                  >
                </template>
                <template v-else>
                  <el-tag type="success" size="small">已完成</el-tag>
                  <span class="finish-time"
                    >完成时间: {{ formatTime(event.updateTime) }}</span
                  >
                </template>
              </div>
              <div class="timeline-time">
                {{ formatTime(event.startTime) }} -
                {{ formatEndTime(event.startTime, event.studyDuration) }}
              </div>
              <div>
                <span :class="['timeline-type', event.type]">
                  {{ event.type === "textBook" ? "阅读" : "习题" }}
                </span>
                <span>{{ event.name }}</span>
              </div>
              <div style="margin-top: 10px; color: #666">
                {{ event.description }}
              </div>
              <div
                class="timeline-actions"
                style="margin-top: 10px; text-align: right"
              >
                <!-- <el-button type="text" @click="editEvent(event)" size="small">编辑</el-button> -->
                <el-button
                  type="text"
                  @click="deleteEvent(event)"
                  size="small"
                  style="color: #f56c6c"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="study-plan-container">
      <div class="plan-header">
        <div class="header-left">
          <h2>我的学习计划</h2>
          <div class="study-count">今日已有562人开展学习计划</div>
        </div>
        <el-button type="primary" class="add-plan-btn" @click="addStudyPlan">
          <i class="el-icon-plus"></i> 添加计划
        </el-button>
      </div>

      <div class="calendar-container">
        <el-calendar v-model="currentDate">
          <template slot="dateCell" slot-scope="{ date, data }">
            <div
              :class="{ 'has-events': hasEvents(date) }"
              @click="hasEvents(date) && showDayEvents(date)"
            >
              {{ data.day.split("-").slice(2).join("") }}
            </div>
          </template>
        </el-calendar>
      </div>
    </div> -->

    <!-- 日期计划时间轴对话框 -->
    <el-dialog title="学习计划" :visible.sync="dialogVisible" width="600px">
      <div class="timeline-container">
        <div
          @click="addStudyPlanTwo"
          style="margin-bottom: 12px"
          class="setPlan-Box"
        >
          <img src="@/assets/images/studyPlan/workImg01.png" alt="" />
          <span>制定学习计划</span>
        </div>
        <div class="setPlan-Two">
          <div
            v-for="(event, index) in selectedDate.list"
            :key="index"
            class="setPlan-Box-item"
          >
            <div class="setPlan-Box-position">
              <img
                @click="editEvent(event)"
                src="@/assets/images/studyPlan/workImg02.png"
                alt=""
              />
              <img
                @click="deleteEvent(event)"
                src="@/assets/images/studyPlan/workImg03.png"
                alt=""
              />
            </div>
            <div class="setPlan-Box-item-title">
              <img
                src="@/assets/images/studyPlan/icon_textbook.png"
                v-if="event.type === 'textBook'"
                alt=""
              />
              <img
                src="@/assets/images/studyPlan/icon_test.png"
                v-else
                alt=""
              />
              <span>{{ event.name }}</span>
            </div>
            <div class="setPlan-Box-item-time">
              <span>
                {{ formatTimeTwo(event.startTime) }}
                {{ formatTime(event.startTime) }}-{{
                  formatEndTime(event.startTime, event.studyDuration)
                }}
              </span>
              <!-- <span>2026/01/03-2026/05/11 14:30-16:00</span> -->
            </div>
            <div class="setPlan-Box-item-time">
              创建时间：{{ event.createTime }}
            </div>
          </div>
        </div>

        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关闭</el-button>
        </span> -->
      </div>
    </el-dialog>
    <!-- 日期计划时间轴对话框 -->
    <el-dialog
      v-if="false"
      :title="selectedDate.title + ' 学习计划'"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <div class="timeline-container">
        <div class="timeline-container-listBox">
          <div
            v-for="(event, index) in selectedDate.list"
            :key="index"
            class="timeline-item"
          >
            <div class="timeline-content">
              <div class="timeline-status">
                <!-- 只保留待完成和已完成状态 -->
                <template v-if="event.status != '6'">
                  <el-tag type="warning" size="small">待完成</el-tag>
                  <el-button
                    type="success"
                    size="small"
                    @click="completeEvent(event)"
                    >完成计划</el-button
                  >
                </template>
                <template v-else>
                  <el-tag type="success" size="small">已完成</el-tag>
                  <span class="finish-time"
                    >完成时间: {{ formatTime(event.updateTime) }}</span
                  >
                </template>
              </div>
              <div class="timeline-time">
                {{ formatTime(event.startTime) }} -
                {{ formatEndTime(event.startTime, event.studyDuration) }}
              </div>
              <div>
                <span :class="['timeline-type', event.type]">
                  {{ event.type === "textBook" ? "阅读" : "习题" }}
                </span>
                <span>{{ event.name }}</span>
              </div>
              <div style="margin-top: 10px; color: #666">
                {{ event.description }}
              </div>
              <div
                class="timeline-actions"
                style="margin-top: 10px; text-align: right"
              >
                <!-- <el-button type="text" @click="editEvent(event)" size="small">编辑</el-button> -->
                <el-button
                  type="text"
                  @click="deleteEvent(event)"
                  size="small"
                  style="color: #f56c6c"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="editingEvent ? '编辑学习计划' : '制定学习计划'"
      :visible.sync="editDialogVisible"
      width="600px"
    >
      <el-form :model="studyPlan" label-width="100px">
        <el-form-item label="计划类型">
          <el-radio-group v-model="studyPlan.type">
            <el-radio label="reading">阅读</el-radio>
            <el-radio label="exercise">题库练习</el-radio>
            <el-radio label="exam">试卷练习</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="studyPlan.type === 'reading'">
          <el-form-item label="阅读章节">
            <el-cascader
              class="inputCommonStyle01"
              v-model="studyPlan.chapterId"
              :options="dataList"
              :props="{
                value: 'id',
                label: 'label',
                children: 'children',
                expandTrigger: 'hover',
              }"
              placeholder="请选择计划阅读的章节"
              @change="handleChapterChange"
              style="width: 100%"
            >
              <template slot-scope="{ node, data }">
                <span>
                  <i
                    :class="data.icon || 'el-icon-folder'"
                    style="margin-right: 5px"
                  ></i>
                  {{ data.label }}
                </span>
              </template>
            </el-cascader>
          </el-form-item>
          <!-- <el-form-item label="学习时长">
            <el-input-number
              v-model="studyPlan.duration"
              :min="1"
              :max="480"
              :step="1"
              placeholder="请输入学习时长（分钟）"
            >
            </el-input-number>
            <span style="margin-left: 10px">分钟</span>
          </el-form-item> -->
        </template>

        <!-- <template v-if="studyPlan.type === 'exercise'"> -->
        <!-- <el-form-item label="习题类型">
            <el-radio-group v-model="studyPlan.exerciseType">
              <el-radio label="questionBank">选择题库</el-radio>
              <el-radio label="exam">选择试卷</el-radio>
            </el-radio-group>
          </el-form-item> -->
        <template v-if="studyPlan.type === 'exercise'">
          <el-form-item label="题目数量">
            <el-input-number
              class="inputCommonStyle01"
              style="width: 100%"
              v-model="studyPlan.questionCount"
              :min="1"
              :max="50"
              :step="1"
              placeholder="请输入题目数量"
            >
            </el-input-number>
            <!-- <span style="margin-left: 10px">道</span> -->
          </el-form-item>
        </template>
        <template v-if="studyPlan.type === 'exam'">
          <el-form-item label="练习试卷">
            <el-select
              class="inputCommonStyle01"
              v-model="studyPlan.examId"
              placeholder="请选择计划练习的试卷"
              @change="handChange03"
            >
              <el-option
                v-for="exam in examList"
                :key="exam.id"
                :label="exam.name"
                :value="exam.id"
              >
                <span>{{ exam.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">
                  {{ exam.questionCount }}题 / {{ exam.duration }}分钟
                </span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="考试时长">
            <!-- v-model="studyPlan.duration" -->
            <el-input
              class="inputCommonStyle01"
              style="width: 100%"
              v-model="studyPlan.duration"
              :disabled="true"
            >
            </el-input>

            <!-- <span style="margin-left: 10px">分钟</span> -->
          </el-form-item>
        </template>
        <!-- </template> -->
        <el-form-item
          v-if="studyPlan.type == 'reading' || studyPlan.type == 'exercise'"
          label="学习时间"
        >
          <div class="time-picker-boxGroud">
            <div class="time-picker-icon">
              <i class="el-icon-date"></i>
            </div>
            <el-time-picker
              style="width: 210px"
              class="inputCommonStyle03 inputCommonStyle02"
              v-model="studyPlan.startTime"
              format="HH:mm"
              placeholder="选择开始时间"
            >
            </el-time-picker>
            <div>-</div>
            <el-time-picker
              style="width: 210px"
              class="inputCommonStyle03 inputCommonStyle02"
              v-model="studyPlan.endTime"
              format="HH:mm"
              placeholder="选择结束时间"
            >
            </el-time-picker>
          </div>
        </el-form-item>
        <!-- <el-form-item
          v-if="studyPlan.type == 'reading' || studyPlan.type == 'exercise'"
          label="学习时间"
        >

          <el-date-picker
            class="date-picker-box01 inputCommonStyle01"
            prefix-icon="el-icon-date"
            style="width: 100%"
            v-model="studyPlan.timeRange"
            type="datetimerange"
            range-separator="-"
            start-placeholder="请选择开始时间"
            end-placeholder="请选择结束时间"
            @change="hangChange02"
          >
            <template> </template>
          </el-date-picker>
        </el-form-item> -->
        <el-form-item v-if="studyPlan.type == 'exam'" label="开始时间">
          <el-time-picker
            style="width: 100%"
            class="inputCommonStyle01 date-picker-box02"
            v-model="studyPlan.startTime"
            format="HH:mm"
            prefix-icon="el-icon-date"
            placeholder="请选择开始时间"
          >
          </el-time-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveStudyPlan">确定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑计划对话框 -->
    <!-- <el-dialog
      :title="editingEvent ? '编辑计划' : '添加计划'"
      :visible.sync="editDialogVisible"
      width="35%"
    >
      <el-form :model="studyPlan" label-width="100px">
        <el-form-item label="计划类型">
          <el-radio-group v-model="studyPlan.type">
            <el-radio label="reading">阅读数字教材</el-radio>
            <el-radio label="exercise">作答习题</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="studyPlan.type === 'reading'">
          <el-form-item label="选择章节">
            <el-cascader
              v-model="studyPlan.chapterId"
              :options="dataList"
              :props="{
                value: 'id',
                label: 'label',
                children: 'children',
                expandTrigger: 'hover',
              }"
              placeholder="请选择要阅读的章节"
              @change="handleChapterChange"
              style="width: 100%"
            >
              <template slot-scope="{ node, data }">
                <span>
                  <i
                    :class="data.icon || 'el-icon-folder'"
                    style="margin-right: 5px"
                  ></i>
                  {{ data.label }}
                </span>
              </template>
            </el-cascader>
          </el-form-item>
          <el-form-item label="学习时长">
            <el-input-number
              v-model="studyPlan.duration"
              :min="1"
              :max="480"
              :step="1"
              placeholder="请输入学习时长（分钟）"
            >
            </el-input-number>
            <span style="margin-left: 10px">分钟</span>
          </el-form-item>
        </template>

        <template v-if="studyPlan.type === 'exercise'">
          <el-form-item label="习题类型">
            <el-radio-group v-model="studyPlan.exerciseType">
              <el-radio label="questionBank">选择题库</el-radio>
              <el-radio label="exam">选择试卷</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="studyPlan.exerciseType === 'questionBank'">
            <el-form-item label="题目数量">
              <el-input-number
                v-model="studyPlan.questionCount"
                :min="1"
                :max="50"
                :step="1"
                placeholder="请输入题目数量"
              >
              </el-input-number>
              <span style="margin-left: 10px">道</span>
            </el-form-item>
            <el-form-item label="学习时长">
              <el-input-number
                v-model="studyPlan.duration"
                :min="1"
                :max="180"
                :step="1"
                placeholder="请输入学习时长（分钟）"
              >
              </el-input-number>
              <span style="margin-left: 10px">分钟</span>
            </el-form-item>
          </template>
          <template v-if="studyPlan.exerciseType === 'exam'">
            <el-form-item label="选择试卷">
              <el-select v-model="studyPlan.examId" placeholder="请选择试卷">
                <el-option
                  v-for="exam in examList"
                  :key="exam.id"
                  :label="exam.name"
                  :value="exam.id"
                >
                  <span>{{ exam.name }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ exam.questionCount }}题 / {{ exam.duration }}分钟
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </template>
        <el-form-item label="开始时间">
          <el-time-picker
            v-model="studyPlan.startTime"
            format="HH:mm"
            placeholder="选择开始时间"
          >
          </el-time-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveStudyPlan">确定</el-button>
      </span>
    </el-dialog> -->
  </el-drawer>
</template>

<script>
import {
  addStudyPlan,
  getStudyPlan,
  getPlanInfo,
  deletePlan,
  updatePlan,
} from "@/api/plan.js";
export default {
  name: "StudyPlan",
  props: { dataList: Array },

  data() {
    return {
      value2: "",
      switchIcon01: true,
      currentDate: new Date(),
      studyPlan: {
        type: "reading",
        date: "",
        startTime: null,
        duration: 30,
        chapterId: null,
        chapter: null,
        exerciseType: "questionBank",
        questionCount: 13,
        examId: null,
        id: null,
        
      },
      examList: [
        {
          id: 1,
          name: "期中考试模拟试卷",
          questionCount: 20,
          duration: 120,
        },
        {
          id: 2,
          name: "期末考试模拟试卷",
          questionCount: 25,
          duration: 150,
        },
      ],
      chapterTree: [
        {
          id: 1,
          label: "第一章 绪论",
          icon: "el-icon-notebook-2",
          children: [
            {
              id: 11,
              label: "1.1 课程介绍",
              icon: "el-icon-document",
            },
            {
              id: 12,
              label: "1.2 学习目标",
              icon: "el-icon-document",
            },
          ],
        },
        {
          id: 2,
          label: "第二章 基础知识",
          icon: "el-icon-notebook-2",
          children: [
            {
              id: 21,
              label: "2.1 基本概念",
              icon: "el-icon-document",
            },
            {
              id: 22,
              label: "2.2 理论框架",
              icon: "el-icon-document",
            },
          ],
        },
      ],
      studyEvents: [],
      dialogVisible: false,
      selectedDate: {
        title: "",
        list: [],
      },
      editDialogVisible: false,
      editingEvent: null,
      planDialogVisible: false,
    };
  },
  created() {},
  mounted() {},
  methods: {
    handChange04(startTime, studyDuration) {
      console.log(startTime, "附件里是看得见", studyDuration);
      // 将 startTime 转换为 Date 对象
      const startDate = new Date(startTime);

      // 加上 studyDuration 分钟
      const endDate = new Date(startDate.getTime() + studyDuration * 60000);

      // 返回 HH:mm 格式的时间
      console.log(this.formatTime(endDate), "军事科技的", endDate);

      return endDate;
    },
    handChange03() {
      let exam = this.examList.find((e) => e.id === this.studyPlan.examId);
      this.studyPlan.duration = exam.duration;
      this.studyPlan.name = exam.name;
    },
    handClick01() {
      this.switchIcon01 = !this.switchIcon01;
    },
    hangChange02() {
      const startTime = new Date(this.studyPlan.startTime);
      const endTime = new Date(this.studyPlan.endTime);

      // 获取开始时间
      this.studyPlan.startTime = this.formatDateY(startTime);

      // 计算分钟差
      const diffInMilliseconds = endTime - startTime;
      const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

      // 如果需要，可以转换为小时和分钟
      const hours = Math.floor(diffInMinutes / 60);
      const minutes = diffInMinutes % 60;

      console.log("开始时间:", this.studyPlan.startTime);
      console.log("结束时间:", this.formatDateY(endTime));
      console.log("总分钟数:", diffInMinutes);
      console.log("时长:", `${hours}小时${minutes}分钟`);

      // 存储到 studyPlan
      this.studyPlan.duration = diffInMinutes; // 存储总分钟数
      this.studyPlan.durationText = `${hours}小时${minutes}分钟`;
    },
    // 将开始时间的时分秒付给选中日期
    formatDateTwo(startTime, currentDate) {
      if (!startTime || !currentDate) {
        return;
      }
      let str01 = this.formatDateY(currentDate).split(" ")[0];
      let str02 = this.formatDateY(startTime).split(" ")[1];
      console.log(str01 + " " + str02, "吉萨空间");
      return this.formatDateY(str01 + " " + str02);
    },

    hangChange01() {
      console.log(this.value2, "this.value2");
      console.log(this.currentDate, "this.currentDate");
      this.currentDate = this.value2;
    },
    toggleDatePicker(index) {
      if (index == 1) {
        this.$refs.datePicker01.focus();
      }
      if (index == 2) {
        this.$refs.datePicker02.focus();
      }
      //   // 切换日期选择器的显示/隐藏
      //   if (this.switchIcon01) {
      //     this.$refs.datePicker.pickerVisible = false;
      //   } else {
      //     this.$refs.datePicker.focus();
      //   }
      //   this.switchIcon01 = !this.switchIcon01;
    },

    open() {
      let today = new Date();
      let todayString =
        today.getFullYear() +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(today.getDate()).padStart(2, "0");
      console.log("打开抽屉", todayString);
      this.planDialogVisible = true;
      this.getStudyPlanList(this.currentDate);
      this.showDayEvents(todayString);
    },
    handleChapterChange(value) {
      if (value && value.length > 0) {
        const chapterId = value[value.length - 1];
        const chapter = this.findChapterById(this.chapterTree, chapterId);
        if (chapter) {
          this.studyPlan.chapter = chapter;
          this.studyPlan.name = chapter.label;
        }
      }
    },
    findChapterById(chapters, id) {
      for (const chapter of chapters) {
        if (chapter.id === id) {
          return chapter;
        }
        if (chapter.children) {
          const found = this.findChapterById(chapter.children, id);
          if (found) return found;
        }
      }
      return null;
    },
    saveToLocalStorage() {},
    resetStudyPlan() {
      this.studyPlan = {
        type: "reading",
        date: "",
        startTime: null,
        duration: 30,
        chapterId: null,
        chapter: null,
        exerciseType: "questionBank",
        questionCount: 13,
        examId: null,
      };
      this.editingEvent = null;
    },
    addStudyPlan() {
      this.resetStudyPlan();
      // this.editDialogVisible = true;
      this.dialogVisible = true;
    },
        addStudyPlanTwo() {
      this.resetStudyPlan();
      this.editDialogVisible = true;

    },
    saveStudyPlan() {
      if (
        this.studyPlan.type == "reading" ||
        this.studyPlan.type == "exercise"
      ) {
        if (!this.studyPlan.startTime || !this.studyPlan.startTime) {
          this.$message.warning("请选择开始时间和结束时间");
          return;
        } else if (
          new Date(this.studyPlan.startTime) >= new Date(this.studyPlan.endTime)
        ) {
          this.$message.warning("设置开始时间要早于结束时间");
          return;
        } else {
          // 设置阅读时间
          this.hangChange02();
        }
      }
      // 试卷
      else {
        if (!this.studyPlan.startTime) {
          this.$message.warning("请选择开始时间");
          return;
        }
      }

      //       if (this.studyPlan.type === "exercise") {
      //   if (this.studyPlan.exerciseType === "questionBank") {
      //     this.studyPlan.name = `选择题库 - ${this.studyPlan.questionCount}道题`;
      //   } else if (
      //     this.studyPlan.exerciseType === "exam" &&
      //     !this.studyPlan.examId
      //   ) {
      //     this.$message.warning("请选择试卷");
      //     return;
      //   } else if (this.studyPlan.exerciseType === "exam") {
      //     const exam = this.examList.find(
      //       (e) => e.id === this.studyPlan.examId,
      //     );
      //     this.studyPlan.duration = exam.duration;
      //     this.studyPlan.name = exam.name;
      //   }
      // }

      // if (this.studyPlan.type === "exercise") {
      if (this.studyPlan.type === "exercise") {
        this.studyPlan.name = `选择题库 - ${this.studyPlan.questionCount}道题`;
      } else if (this.studyPlan.type === "exam" && !this.studyPlan.examId) {
        this.$message.warning("请选择试卷");
        return;
      } else if (this.studyPlan.type === "exam") {
        const exam = this.examList.find((e) => e.id === this.studyPlan.examId);
        this.studyPlan.duration = exam.duration;
        this.studyPlan.name = exam.name;
      }
      // }

      if (this.editingEvent) {
        // 编辑现有计划
             let type = {
        reading: "textBook",
        exercise: "testPaper",
        exam: "testPaper",
      };
          updatePlan({
            id:   this.studyPlan.id,
        type: type[this.studyPlan.type],
        // paperType:paperType[this.studyPlan.exerciseType],
        questionNum: this.studyPlan.questionCount || 0,
        looseLeafId: this.studyPlan.chapterId.toString(),
        startTime:
          this.formatDateTwo(this.studyPlan.startTime, this.currentDate) || "",
        studyDuration: this.studyPlan.duration || 0,
        stutyTime: this.formatDateY(this.currentDate),
        name: this.studyPlan.name,
          }).then(() => {
            this.showDayEvents(this.currentDate);
            this.$message.success("计划已标记为完成");
          });
        
      } else {
        // 添加新计划
        this.submitStudyPlan();
      }

      // this.saveToLocalStorage();
      this.editDialogVisible = false;
      this.resetStudyPlan();
    },
    // 确认添加计划
    submitStudyPlan() {
      let type = {
        reading: "textBook",
        exercise: "testPaper",
        exam: "testPaper",
      };
      let paperType = {
        questionBank: "question",
        exam: "paper",
      };
      console.log(this.studyPlan.type, "this.studyPlan.type");

      let startTime = this.formatDateY(this.studyPlan.startTime);
      console.log(this.studyPlan.startTime, "this.studyPlan.startTime01");
      console.log(startTime, "this.studyPlan.startTime02");
      addStudyPlan({
        type: type[this.studyPlan.type],
        // paperType:paperType[this.studyPlan.exerciseType],
        questionNum: this.studyPlan.questionCount || 0,
        looseLeafId: this.studyPlan.chapterId.toString(),
        startTime:
          this.formatDateTwo(this.studyPlan.startTime, this.currentDate) || "",
        studyDuration: this.studyPlan.duration || 0,
        stutyTime: this.formatDateY(this.currentDate),
        name: this.studyPlan.name,
      }).then((res) => {
        this.getStudyPlanList(this.currentDate);
        this.$message.success("计划添加成功");
      });
    },

    //
    getStudyPlanList(date) {
      getStudyPlan({ month: this.getTime(date, "YYYY-MM") }).then((res) => {
        this.studyEvents = res.data || [];
        // this.showDayEvents(this.currentDate);
        getPlanInfo({ days: this.getTime(date, "YYYY-MM-DD") }).then((res) => {
          this.selectedDate = {
            title: this.getTime(date, "YYYY-MM-DD"),
            list: res.data || [],
          };
          console.log(this.selectedDate, "this.selectedDate");
        });
      });
    },
    editEvent(event) {
      this.editingEvent = event;
      this.studyPlan = {
        type: event.type,
        date: event.date,
        startTime: event.startTime,
        endTime: this.handChange04(event.startTime, event.studyDuration),
        duration: event.studyDuration,
        chapterId: event.chapter ? event.chapter.id : null,
        chapter: event.chapter,
        exerciseType: event.exerciseType,
        questionCount: event.questionNum,
        examId: event.examId,
        id: event.id,
      };
      this.editDialogVisible = true;
      this.studyPlan.type = "reading";
    },
    deleteEvent(event) {
      this.$confirm("确认删除该计划吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deletePlan(event.id).then(() => {
            this.showDayEvents(this.currentDate);
            this.getStudyPlanList(this.currentDate);
            this.$message.success("计划删除成功");
          });
        })
        .catch(() => {});
    },
    getEventsByDate(date) {
      if (!date) return [];
      const dateStr = this.formatDate(date);
      return this.studyEvents
        .filter((event) => event.date === dateStr)
        .sort((a, b) => a.startTime - b.startTime);
    },
    hasEvents(date) {
      if (!date) return false;
      return (
        JSON.stringify(this.studyEvents).indexOf(
          this.getTime(date, "YYYY-MM-DD"),
        ) != -1
      );
    },
    showDayEvents(date) {
      if (!date) return;
      getPlanInfo({ days: this.getTime(date, "YYYY-MM-DD") }).then((res) => {
        this.selectedDate = {
          title: this.getTime(date, "YYYY-MM-DD"),
          list: res.data || [],
        };
        // console.log(this.selectedDate, "this.selectedDate");
      });
       
      this.selectedDate = this.formatDate(date);
        console.log(this.selectedDate, "this.selectedDate");
      // this.dialogVisible = true;
    },
    formatDate(date) {
      if (!date) return "";
      // 处理日期字符串格式
      if (typeof date === "string") {
        return date;
      }
      // 处理日期对象
      if (date instanceof Date) {
        return date.toISOString().split("T")[0];
      }
      // 处理其他格式
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatDateY(e) {
      let date = e;
      if (!date) return "";
      // 处理日期字符串格式
      if (typeof date === "string") {
        date = new Date(e);
      }

      // 处理其他格式
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 转化为小时，分钟格式
    formatTime(time) {
      if (!time) return "";
      time = new Date(time);
      const hours = time.getHours().toString().padStart(2, "0");
      const minutes = time.getMinutes().toString().padStart(2, "0");
      return `${hours}:${minutes}`;
    },
    formatTimeTwo(date) {
      if (!date) return "";
      date = new Date(date);

      // 处理其他格式
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return `${year}-${month}-${day}`;
    },
    formatEndTime(startTime, durationBak) {
      console.log(startTime, "startTime", durationBak, "durationBak");
      // 转化为数字
      let duration = Number(durationBak) 
      if (!startTime) return "";
      const endTime = new Date(startTime);
      endTime.setMinutes(endTime.getMinutes() + duration);
      console.log(this.formatTime(endTime),endTime,'就是空的附件是看');
      return this.formatTime(endTime);
    },

    //根据时间获取状态
    getStatus(startTime, endTime) {
      // console.log(startTime, "和数据库", endTime);

      const now = new Date();
      const start = new Date(startTime);
      const end = new Date(endTime);
      // console.log(start, "就是卡琳娜", end);

      // 未开始：当前时间 < 开始时间
      if (now < start) {
        return 0; // 未开始
      }

      // 进行中：当前时间 >= 开始时间 且 当前时间 <= 结束时间
      if (now >= start && now <= end) {
        return 1; // 进行中
      }

      // 已结束：当前时间 > 结束时间
      return 2; // 已结束
    },

    getTime(date, format) {
      let d = new Date(date);
      let Y = "";
      let M = "";
      let D = "";
      if (format.indexOf("Y") != -1) {
        Y = d.getFullYear();
      }
      if (format.indexOf("M") != -1) {
        M =
          "-" +
          (d.getMonth() + 1 > 9 ? d.getMonth() + 1 : "0" + (d.getMonth() + 1));
      }
      if (format.indexOf("D") != -1) {
        D = "-" + (d.getDate() > 9 ? d.getDate() : "0" + d.getDate());
      }

      return Y + M + D;
    },
    completeEvent(event) {
      this.$confirm("确定要将该计划标记为已完成吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          updatePlan({
            id: event.id,
            status: 6,
          }).then(() => {
            this.showDayEvents(this.currentDate);
            this.$message.success("计划已标记为完成");
          });

          // 如果有后端接口，建议调用接口后再设置finishTime
        })
        .catch(() => {
          // 用户取消，无需处理
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .time-picker-boxGroud {
    display: flex;
    align-items: center;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #cbd5e0;
    height: 36px;
    position: relative;
    .el-input__prefix {
      display: none;
    }
    .el-input__suffix {
      top: -3px;
    }
    .time-picker-icon {
      position: absolute;
      right: 10px;
      top: 50%;
      color: #999999;
      font-size: 16px;
      transform: translateY(-50%);
    }
  }

  .calendar-box {
    .el-date-editor {
      position: absolute;
      left: -35px;
    }
    .el-calendar {
      border-radius: 5px;
      overflow: hidden;
    }
    .el-input__prefix {
      opacity: 0;
      z-index: -1;
    }
  }
  .calendar-box02 {
    .el-calendar {
      height: 100px;
    }
  }
  .time-switch-box02 {
    .el-input__inner {
      position: absolute;
      left: -32px;
      top: 7px;
      opacity: 0;
      height: 12px;
      z-index: -1;
    }
  }

  .calendar-container {
    /* margin: 20px 30px; */
    /* background: white; */
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
    /* padding: 30px; */
  }

  .el-calendar-table td {
    padding: 8px;
    position: relative;
  }

  .el-calendar-table td.is-today {
    background-color: #ecf5ff;
  }

  .el-calendar-table td.is-today .has-events {
    background: linear-gradient(45deg, #409eff, #67c23a);
    color: white;
  }

  .has-events {
    position: relative;
    background: linear-gradient(45deg, #409eff, #67c23a);
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s;
    padding: 4px 8px;
    margin: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 32px;
    font-weight: 500;
    color: white;
  }

  .has-events::before {
    content: "";
    position: absolute;
    top: 2px;
    right: 2px;
    width: 6px;
    height: 6px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
  }

  .has-events:hover {
    background: linear-gradient(45deg, #66b1ff, #85ce61);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
  }

  .has-events:hover::before {
    background-color: white;
  }

  .el-calendar-table th {
    padding: 12px;
    font-weight: 600;
    color: #606266;
    background-color: #f8f9fa;
  }

  .el-calendar__header {
    padding: 0 0 20px 0;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 20px;

    .el-calendar__title {
      font-size: 20px;
      font-weight: 600;
      color: #303133;
    }

    .el-calendar__button-group {
      .el-button {
        padding: 8px 16px;
        border-radius: 8px;
        font-weight: 500;
        transition: all 0.3s;

        &:hover {
          transform: translateY(-2px);
        }
      }
    }
  }

  .el-calendar-table {
    th {
      padding: 12px;
      font-weight: 600;
      color: #606266;
      background: #f8f9fa;
    }

    td {
      padding: 8px;

      .cell {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .has-events {
      position: relative;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: linear-gradient(135deg, #409eff, #67c23a);
      color: white;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        transform: scale(1.1);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
      }

      &::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-50%);
        width: 4px;
        height: 4px;
        background: #409eff;
        border-radius: 50%;
      }
    }
  }

  .timeline-container {
    // padding: 20px;
    border-top: 1px solid #edf2f7;
    padding-top: 12px;
    .timeline-container-listBox {
    }
    .dialog-footer {
      padding: 8px 0px 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    .setPlan-Box {
      width: 126px;
      cursor: pointer;
      height: 28px;
      background: #2d68fe;
      border-radius: 3px 3px 3px 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 6px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
    }
    .setPlan-Box-item {
      margin-bottom: 12px;
      width: 100%;

      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #cbd5e0;
      padding: 10px 12px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 10px;
      position: relative;
      .setPlan-Box-position {
        position: absolute;
        right: 12px;
        bottom: 12px;
        display: flex;
        align-items: center;
        gap: 8px;
        > img {
          cursor: pointer;
        }
      }

      .setPlan-Box-item-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-family: MiSans, MiSans;
        font-weight: 500;
        font-size: 16px;
        color: #191919;
        > img {
          width: 20px;
          height: 20px;
        }
      }
      .setPlan-Box-item-time {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 14px;
        color: #626262;
      }
    }
  }

  .timeline-item {
    position: relative;
    padding-left: 40px;
    margin-bottom: 30px;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 2px;
      background: linear-gradient(to bottom, #409eff, #67c23a);
    }

    &::after {
      content: "";
      position: absolute;
      left: -8px;
      top: 12px;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: white;
      border: 3px solid #409eff;
      box-shadow: 0 0 0 4px #ecf5ff;
    }

    .timeline-content {
      background: white;
      padding: 24px;
      border-radius: 12px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
      transition: all 0.3s;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
      }

      /* 新增：时间线状态样式 */
      .timeline-status {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 10px;
        min-height: 32px;
      }

      .timeline-status .el-tag {
        font-size: 13px;
        border-radius: 8px;
        padding: 2px 12px;
        font-weight: 500;
        letter-spacing: 1px;
      }

      .timeline-status .el-button {
        margin-left: 8px;
        padding: 4px 14px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 500;
        box-shadow: 0 2px 8px rgba(103, 194, 58, 0.08);
        transition: all 0.2s;
      }

      .timeline-status .finish-time {
        color: #67c23a;
        font-size: 13px;
        margin-left: 8px;
        font-weight: 500;
      }

      .timeline-time {
        font-size: 16px;
        font-weight: 600;
        color: #409eff;
        margin-bottom: 12px;
      }

      .timeline-type {
        padding: 6px 16px;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 500;
        margin-right: 12px;

        &.reading {
          background: #f0f9eb;
          color: #67c23a;
        }

        &.exercise {
          background: #ecf5ff;
          color: #409eff;
        }
      }
    }
  }

  .study-plan-dialog {
    .el-dialog__body {
      padding: 0 20px 0px;
    }
    .el-dialog__headerbtn {
      top: 15px;
    }

    .el-form {
      padding-top: 24px;
      border-top: 1px solid #edf2f7;

      .el-form-item {
        margin-bottom: 24px;
        .el-input-number {
          .el-input-number__decrease {
            display: none;
          }
          .el-input-number__increase {
            display: none;
          }
        }

        .el-form-item__label {
          font-family: MiSans, MiSans;
          font-weight: 500;
          font-size: 14px;
          color: #191919;
          padding-right: 32px;
        }
        .el-radio-group {
          .el-radio {
            .el-radio__label {
              font-family: MiSans, MiSans;
              font-weight: 400;
              font-size: 14px;
              color: #191919;
            }
          }
        }
        .date-picker-box01 {
          .el-input__icon {
            font-size: 16px;
            position: absolute;
            right: 12px;
          }
        }
        .date-picker-box02 {
          .el-input__prefix {
            font-size: 16px;
            position: absolute;
            right: 12px;
            left: auto !important;
          }
          .el-input__suffix { 
                   position: absolute;
            right: 33px;
            left: auto !important;
          }
        }
        .inputCommonStyle01 {
          height: 36px;
          line-height: 36px;
          .el-input__inner {
            height: 36px !important;
            line-height: 36px !important;
          }
        }
        .inputCommonStyle03 {
          height: 34px;
          line-height: 34px;
          .el-input__inner {
            height: 34px !important;
            line-height: 34px !important;
          }
        }
        .inputCommonStyle02 {
          .el-input__inner {
            border: 0px solid #dcdfe6 !important;
          }
        }
        // .el-radio-group {
        //   .el-radio {
        //     margin-right: 30px;
        //     padding: 12px 20px;
        //     border-radius: 8px;
        //     border: 1px solid #dcdfe6;
        //     transition: all 0.3s;

        //     &:hover {
        //       border-color: #409eff;
        //       background: #ecf5ff;
        //     }

        //     &.is-checked {
        //       background: #ecf5ff;
        //       border-color: #409eff;
        //     }

        //     .el-radio__label {
        //       font-size: 14px;
        //     }
        //   }
        // }

        .el-cascader,
        .el-select,
        .el-time-picker {
          width: 100%;

          .el-input__inner {
            height: 44px;
            line-height: 44px;
            border-radius: 8px;
            border: 1px solid #dcdfe6;
            transition: all 0.3s;

            &:hover {
              border-color: #409eff;
            }

            &:focus {
              border-color: #409eff;
              box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
            }
          }
        }

        .el-input-number {
          width: 180px;

          .el-input__inner {
            height: 44px;
            line-height: 44px;
            border-radius: 8px;
          }
        }
      }
    }
    .el-dialog__footer {
      text-align: center;
    }
    .dialog-footer {
      // padding-top: 20px;
      // border-top: 1px solid #ebeef5;
      text-align: right;

      .el-button {
        padding: 12px 24px;
        font-size: 15px;
        border-radius: 8px;
        transition: all 0.3s;

        &--default {
          border: 1px solid #dcdfe6;

          &:hover {
            border-color: #409eff;
            color: #409eff;
          }
        }

        &--primary {
          background: linear-gradient(135deg, #409eff, #67c23a);
          border: none;
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(64, 158, 255, 0.3);
          }
        }
      }
    }
  }

  .el-dialog {
    border-radius: 12px;
    overflow: hidden;
  }

  .el-dialog__header {
    // background: #f8f9fa;
    // padding: 20px;
    // border-bottom: 1px solid #ebeef5;

    background: white;
    padding: 12px 20px 13px;
    border-bottom: none;
  }

  .el-dialog__title {
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
  }

  .el-dialog__body {
    padding: 30px;
  }

  .el-form-item__label {
    font-weight: 500;
    color: #606266;
  }

  .el-input__inner {
    border-radius: 6px;
  }

  .el-button {
    border-radius: 6px;
    padding: 11px 30px !important;
  }
  .el-button--default {
    background: #edf2f7 !important;
    border: 1px solid #a1a1a1 !important;
  }
  .el-button--primary {
    // background: linear-gradient(45deg, #409eff, #67c23a);
    border: none;
    background: #2d68fe !important;
  }

  .el-button--primary:hover {
    // background: linear-gradient(45deg, #66b1ff, #85ce61);
    background: #2d68fe !important;
  }

  .el-calendar {
    background: transparent;
  }

  .el-calendar__header {
    padding: 20px;
  }

  .el-calendar__body {
    padding: 20px;
  }
}
// :deep(.el-input__inner) {
//   width: 0px !important;
//   height: 16px !important;
// }
</style>
<style lang="scss">
body {
  background-color: #f5f7fa;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.study-plan-container {
  max-width: 1200px;
  margin: 0 auto;
  /* padding: 30px; */
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

h2 {
  color: #303133;
  margin-bottom: 30px;
  font-weight: 600;
}

/* 新增和修改的样式 */
// .study-plan-dialog {
//   .el-dialog__header {
//     background: linear-gradient(135deg, #409eff, #67c23a);
//     padding: 20px 30px;
//     border-bottom: none;

//     .el-dialog__title {
//       color: white;
//       font-size: 20px;
//       font-weight: 600;
//     }

//     .el-dialog__headerbtn .el-dialog__close {
//       color: white;
//     }
//   }
// }

.study-plan-container {
  padding: 0;
  background: #f8f9fa;
  border-radius: 0;
  box-shadow: none;
}

.plan-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background: white;
  border-bottom: 1px solid #ebeef5;

  .header-left {
    display: flex;
    align-items: center;
    gap: 15px;

    h2 {
      margin: 0;
      font-size: 22px;
      color: #303133;
    }

    .study-count {
      color: #909399;
      font-size: 14px;
    }
  }

  .add-plan-btn {
    padding: 12px 24px;
    font-size: 15px;
    border-radius: 8px;
    background: linear-gradient(135deg, #409eff, #67c23a);
    border: none;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(64, 158, 255, 0.3);
    }

    i {
      margin-right: 6px;
    }
  }
}

.plan_box {
     padding: 20px 35px 7px;

  .editPlan_btn {
    margin-bottom: 20px;

    .btn {
      cursor: pointer;
     width: 308px;
      height: 36px;
      border-radius: 6px 6px 6px 6px;
      border: 1px dashed #2d68fe;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #2d68fe;
      line-height: 12px;

      img {
        margin-right: 6px;
        width: 16px;
        height: 16px;
      }
    }
  }

  .people_num {
    margin-bottom: 15px;
    font-family: MiSans, MiSans;
    font-weight: 500;
    font-size: 13px;
    color: #3d3d3d;
    line-height: 17px;
  }

  .plan_calendar {
        width: 308px;

    .el-calendar {
      background: rgba(45, 104, 254, 0.05);
      padding: 14px 8px;
    }

    .el-calendar__header {
      padding: 0;
      border-bottom: none;
      margin-bottom: 17px;

      .el-calendar__title {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 13px;
        color: #3d3d3d;
        line-height: 12px;
        white-space: normal;
      }

      .el-calendar__button-group {
        display: none;
      }
    }

    .el-calendar__body {
      padding: 0 8px;

      .el-calendar-table {
        th {
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 12px;
          color: #626262;
          line-height: 12px;
          background: inherit;
          padding: 0 0 16px;
        }

        td {
          padding: 0;
          border: none;

          .el-calendar-day {
            padding: 0;
            height: 24px;
            margin-bottom: 8px;
            text-align: center;

            .day {
              font-family: MiSans, MiSans;
              font-weight: 400;
              font-size: 12px;
              // color: #3D3D3D;
              line-height: 12px;
              text-align: center;
              padding-top: 4px;
            }

            // .has {
            //   margin: 0 auto;
            //   width: 23px;
            //   height: 23px;
            //   border-radius: 50%;
            //   background: #2d68fe;
            //   color: #ffffff;
            //   display: flex;
            //   align-content: center;
            //   justify-content: center;
            // }
            .has {
              color: #303133;
              &::after {
                content: "";
                position: absolute;
                bottom: 4px;
                left: 50%;
                transform: translateX(-50%);
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background: #fd8337;
              }
            }
          }
        }

        .is-today {
          .el-calendar-day {
            .day {
              margin: 0 auto;
              width: 22px;
              height: 22px;
              border-radius: 50%;
              color: #2d68fe !important;
              border: 1px solid #2d68fe;
              display: flex;
              align-content: center;
              justify-content: center;
            }

            .has {
              width: 23px;
              height: 23px;
              color: #ffffff;
            }
          }
        }

        .is-selected {
          .el-calendar-day {
            .day {
              margin: 0 auto;
              width: 22px;
              height: 22px;
              border-radius: 50%;
              color: white !important;
              border: 1px solid #2d68fe;
              display: flex;
              background: #2d68fe;
              align-content: center;
              justify-content: center;
            }

            .has {
              width: 23px;
              height: 23px;
              color: #ffffff;
            }
          }
        }
      }
    }

    .plan_list {
      margin-top: 12px;
      padding-bottom: 26px;
      overflow-y: scroll;
      max-height: 480px;
      padding-left: 6px;
      .timeline-item {
        position: relative;
        padding-left: 18px;
        margin-bottom: 0;
        padding-bottom: 30px;
        .timeline-item-img {
          position: absolute;
          width: 16px;
          height: 16px;
          left: -7px;
          top: -1px;
          z-index: 10;
        }

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 2px;
          // background: linear-gradient(to bottom, #409EFF, #67c23a);
          background: #d8d8d8;
        }

        &::after {
          content: "";
          position: absolute;
          left: -7px;
          top: 0px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #d8d8d8;
          border: none;
          box-shadow: none;
        }

        .time-title {
          display: flex;
          align-items: center;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 12px;
          color: #626262;
          line-height: 12px;
          margin-bottom: 10px;

          img {
            width: 14px;
            height: 14px;
            margin-right: 6px;
          }
        }

        .title_name {
          display: flex;
          align-items: center;
          font-family: MiSans, MiSans;
          font-weight: 400;
          font-size: 13px;
          color: #191919;
          line-height: 12px;
          margin-bottom: 12px;

          img {
            width: 16px;
            height: 16px;
            margin-right: 6px;
          }
        }
      }
    }
  }
}

.calendar-box {
  position: relative;
  .time-switch-box01 {
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    font-family: MiSans, MiSans;

    color: #2d68fe;
    position: absolute;
    right: 10px;
    top: 12px;

    .switch-box-text {
      font-weight: 500;
      font-size: 12px;
    }
    i {
      font-weight: 900;
      font-size: 13px;
    }
  }
  .time-switch-box02 {
    cursor: pointer;
    position: absolute;
    left: 93px;
    top: 12px;
    width: 16px;
    height: 16px;
    .time-switch-box02-position {
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
    }
  }
}
.statusNew {
  padding: 0px 8px;
  border-radius: 12px;
  height: 22px;
  line-height: 22px;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 12px;
  display: inline-block;
}
.statusNew01 {
  color: #2d68fe;
  background: rgba(45, 104, 254, 0.1);
}
.statusNew02 {
  color: #626262;
  background: rgba(98, 98, 98, 0.1);
}
.statusNew03 {
  color: #ffffff;
  background: #fd8337;
}
.hasNew {
  color: #ebeef5;
  &::after {
    content: "";
    position: absolute;
    bottom: 2px;
    left: 50%;
    transform: translateX(-50%);
    width: 4px;
    height: 4px;
    background: #fd8337;
  }
}

.el-date-picker__header {
  padding: 12px;
  margin: 0px;
  background: rgba(45, 104, 254, 0.05);
}
.el-picker-panel__content {
  margin: 0px;
  width: 100% !important;
  padding: 0px 15px 15px;
  background: rgba(45, 104, 254, 0.05);
}
.setPlan-Two {
  max-height: 370px;
  overflow-y: scroll;
}
</style>
